"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const CloseRounded_1 = __importDefault(require("@mui/icons-material/CloseRounded"));
const base_1 = require("@mui/base");
const clsx_1 = __importDefault(require("clsx"));
const Modal = ({ children, title, icon, onCancel, onSubmit, className }, ref) => {
    const content = (0, react_1.useRef)(null);
    const container = (0, react_1.useMemo)(() => {
        const element = document.createElement('div');
        element.classList.add('squiz-fte-scope');
        return element;
    }, []);
    const keydown = (e) => {
        if (e.key === 'Escape') {
            onCancel();
        }
        if (e.key === 'Enter') {
            onSubmit && onSubmit();
        }
    };
    // register key listeners for Enter/Escape on key up so the editor doesn't handle the event as well
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', keydown);
        return () => window.removeEventListener('keydown', keydown);
    }, []);
    // add/remove the modal container from the DOM and focus on the first input
    (0, react_1.useEffect)(() => {
        const firstInput = content.current?.querySelector('input:not([type=hidden]), button');
        document.body.appendChild(container);
        firstInput?.focus();
        return () => {
            document.body.removeChild(container);
        };
    }, [container]);
    return (0, react_dom_1.createPortal)(react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(base_1.FocusTrap, { open: true },
            react_1.default.createElement("div", { ref: ref, className: (0, clsx_1.default)('squiz-fte-modal-wrapper', className), tabIndex: -1 },
                react_1.default.createElement("div", { className: "w-modal-sm my-6 mx-auto" },
                    react_1.default.createElement("div", { className: "squiz-fte-modal" },
                        react_1.default.createElement("div", { className: "squiz-fte-modal-header p-6 pb-4" },
                            react_1.default.createElement("div", { className: "squiz-fte-modal-header-icon mr-1.5 mt-[-1px]" }, icon),
                            react_1.default.createElement("h2", { className: "font-semibold text-gray-900 text-heading-2" }, title),
                            react_1.default.createElement("button", { type: "button", className: "ml-auto -mr-3 -mt-3 bg-transparent border-0 text-gray-600 font-semibold outline-none focus:outline-none hover:text-color-gray-800", onClick: onCancel, "aria-label": "Close" },
                                react_1.default.createElement(CloseRounded_1.default, null))),
                        react_1.default.createElement("div", { className: "squiz-fte-modal-content", ref: content }, children),
                        react_1.default.createElement("div", { className: "squiz-fte-modal-footer p-6 pt-3" },
                            react_1.default.createElement("button", { className: "squiz-fte-modal-footer__button bg-gray-200 text-gray-700 mr-2 hover:bg-gray-300", type: "button", onClick: onCancel, "aria-label": "Cancel" }, "Cancel"),
                            onSubmit && (react_1.default.createElement("button", { className: "squiz-fte-modal-footer__button bg-blue-300 text-white hover:bg-blue-400", type: "button", onClick: onSubmit, "aria-label": "Apply" }, "Apply"))))))),
        react_1.default.createElement("div", { className: "opacity-25 fixed inset-0 z-40 bg-black" })), container);
};
exports.default = (0, react_1.forwardRef)(Modal);
